module.exports = __webpack_public_path__ + "img/title3.f2ac72fa.png";